<template>
  <div class="captcha">
    <slot name="txtBefore"></slot>
    <img :src="imageSrc" alt="Sicherheitscode: Bitte gib die hier gezeigten Zeichen in das Eingabefeld ein. Du kannst dir diese auch vorlesen lassen.">
    <b-input v-model="captchaCode" @input='updateInput()' placeholder="Captcha-Code"></b-input>
    <div v-if="this.captcha.audio" class="captcha-audio-wrapper">
      <audio controls type="audio/wav" id="captcha-audio" :src="audioSrc">
        Dein Browser unterstützt das Abspielen dieser Audiodatei nicht.
      </audio>
    </div>
    <div class="captcha-buttons-wrapper">
      <button type="button" class="captcha-refresh-icon" @click="refreshCaptcha" aria-label="Neuen Sicherheitscode anzeigen">
        <img :src="captchaIconSrc('icon-reload')" alt="" aria-hidden="true"/>
      </button>
      <button type="button" class="captcha-audio-icon" @click="playAudioCaptcha" aria-label="Sicherheitscode vorlesen">
        <img :src="captchaIconSrc('icon-audio')" alt="" aria-hidden="true"/>
      </button>
    </div>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapGetters } from 'vuex'
export default {
  name: 'Captcha',
  data () {
    return {
      captcha: {
        image: '',
        token: '',
        audio: ''
      },
      captchaCode: ''
    }
  },
  methods: {
    updateInput () {
      this.$emit('captchaCode', { captchaCode: this.captchaCode, captchaToken: this.captcha.token })
    },
    refreshCaptcha () {
      this.$apollo.queries.captcha.refetch()
    },
    playAudioCaptcha () {
      document.getElementById('captcha-audio').play()
    }
  },
  computed: {
    ...mapGetters(['brand']),
    captchaIconSrc: function () {
      return (iconName) => `/files/${this.brand}/images/icons/${iconName}.svg`
    },
    imageSrc: function () {
      return 'data:image/png;base64, ' + this.captcha.image
    },
    audioSrc: function () {
      return 'data:audio/wav;base64, ' + this.captcha.audio
    }
  },
  apollo: {
    captcha: function () {
      return wrapQuery(gql`query captcha ($brand: String!) {
        captcha (brand: $brand) {
          image,
          token,
          audio
        }
      }`, this, 'captcha', { brand: this.brand })
    }
  }
}
</script>
